import imageNoImage from "./images/no-image.jpeg";

const IMAGES = {
  imageNoImage,
};

export default IMAGES;
